import { Node, mergeAttributes } from '@tiptap/core'

export const SceneBlock = Node.create({
  name: 'sceneBlock',
  group: 'block',
  atom: true,
  selectable: false,
  draggable: false,

  addAttributes() {
    return {
      clipId: { default: '' },
      sceneLabel: { default: '' },
      clipIndex: { default: 0 },
      duration: { default: 0 },
      clipStartTime: { default: 0 },
      hasAudio: { default: false },
      audioStatus: { default: 'none' },
      clipAudioState: { default: 'no-audio' },
      isStale: { default: false },
      hasVideo: { default: false },
      generationMode: { default: '' },
    }
  },

  parseHTML() {
    return [{ tag: 'div[data-scene-block]' }]
  },

  renderHTML({ HTMLAttributes }) {
    const label = HTMLAttributes.sceneLabel || `Clip ${(HTMLAttributes.clipIndex || 0) + 1}`
    const duration = HTMLAttributes.duration ? `${HTMLAttributes.duration}s` : ''

    const isStale = HTMLAttributes.isStale === true || HTMLAttributes.isStale === 'true'
    const hasVideo = HTMLAttributes.hasVideo === true || HTMLAttributes.hasVideo === 'true'
    const audioState = HTMLAttributes.clipAudioState || 'no-audio'
    const showActions = isStale && hasVideo

    const children: any[] = [
      ['span', { class: 'scene-block-handle', 'data-drag-handle': '', draggable: 'true' }, '\u2261'],
      ['span', { class: 'scene-block-label' }, label],
      ['span', { class: 'scene-block-duration' }, duration],
    ]

    if (showActions) {
      const actionLabel = audioState === 'native-audio' ? 'Regen clip' : 'Re-narrate'
      children.push(['button', {
        class: 'scene-block-action',
        'data-action': audioState === 'native-audio' ? 'regen-clip' : 're-narrate',
        'data-clip-id': HTMLAttributes.clipId,
      }, actionLabel])
    }

    children.push(['span', { class: 'scene-block-line' }])

    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-scene-block': '',
        'data-clip-id': HTMLAttributes.clipId,
        'data-audio-status': HTMLAttributes.audioStatus || 'none',
        'data-has-audio': HTMLAttributes.hasAudio ? 'true' : 'false',
        'data-clip-audio-state': audioState,
        'data-is-stale': isStale ? 'true' : 'false',
        'data-has-video': hasVideo ? 'true' : 'false',
        class: 'scene-block',
      }),
      ...children,
    ]
  },
})
